module.exports = __webpack_public_path__ + "static/media/speaker-audience-view.0f01571f.png";